module.exports = __webpack_public_path__ + "static/media/arrow_w_b.b680bcac.svg";